import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=c295e310&scoped=true&"
import script from "./UserNotifications.vue?vue&type=script&lang=ts&"
export * from "./UserNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=c295e310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c295e310",
  null
  
)

export default component.exports